// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconLayoutDashboard } from '@tabler/icons-react';

const icons = {
    IconLayoutDashboard
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'dashboard',
    title: <FormattedMessage id="dashboard" />,
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'item',
            url: '/dashboard',
            icon: icons.IconLayoutDashboard,
            breadcrumbs: false
        },
    ]
};

export default dashboard;
